import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Label } from 'react-bootstrap'
import { Link } from 'react-router'
import '../components/css/CardList.css'
import StackGrid from 'react-stack-grid'
import RecommendationLabel from '../components/RecommendationLabel'

class CardList extends Component {

    constructor(props) {
        super(props)
        this.renderCards = this.renderCards.bind(this)
        this.state = {
            hasLoaded: [],
            update: false,
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.grid !== undefined) {
            this.setState({ update: !this.state.update }, () => {
                this.renderCards()
            })
        }
    }

    renderCards = () => {
        this.grid.updateLayout()
    }

    render() {
        return (
            <div className='cardContainer'>
                <StackGrid
                    duration={0}
                    component='div'
                    style={{ opacity: 1, zIndex: 0 }}
                    columnWidth={320}
                    gridRef={grid => this.grid = grid}
                >
                    {this.props.filteredIdeasToShow.map((idea, index) =>
                        <Link className='cardLink' to={{ pathname: '/idea/' + idea.key + '/view' }} key={index + 53} style={{ textDecoration: 'none' }}>
                            <div className='cardStyle' key={idea.key}>
                                <div className='cardNameContainer' key={index + 1}>
                                    <h3 className='cardIdeaName' key={index + 11}>{idea.name}</h3>
                                </div>
                                {this.props.showFields.includes('owner') &&
                                    <div className='cardPhotoContainer' key={index}>
                                        {!idea.hasOwnProperty('responsible') &&
                                            <div className='avatarImgContainer'>
                                                {idea.hasOwnProperty('ownerName') &&
                                                    <img key={index + 7} className='cardProfile' src={idea.ownerPhotoURL} alt='owner' />
                                                }
                                            </div>
                                        }
                                        {idea.hasOwnProperty('responsible') &&
                                            <div className='avatarImgContainer'>
                                                {idea.responsible.hasOwnProperty('fullName') &&
                                                    <img key={index + 7} className='cardProfile' src={idea.responsible.photoURL} alt='owner' />
                                                }
                                            </div>             
                                        }
                                    </div>
                                }
                                <div className='cardTags' key={index + 2}>
                                    {this.props.showFields.includes('rec') &&
                                        <div className='cardRecContainer'>
                                            <RecommendationLabel
                                                effortRating={idea.effortRating}
                                                impactRating={idea.impactRating}
                                            />
                                        </div>
                                    }
                                    {this.props.showFields.includes('tags') &&
                                        <div>
                                            {idea.tags &&
                                                idea.tags.map((tag, index) =>
                                                    <span className='cardTagContainer' key={index + 10}>
                                                        <Label bsStyle='primary'>{tag}</Label>
                                                    </span>,
                                                )
                                            }
                                        </div>
                                    }
                                </div>
                                {this.props.showFields.includes('image') &&
                                    <div>
                                        {idea.imageUrl &&
                                            <div className='cardImageContainer' key={index + 3}>
                                                <img key={index + 9} className='cardImage' src={idea.imageUrl} alt='idea' />
                                            </div>
                                        }
                                    </div>
                                }
                                {this.props.showFields.includes('desc') &&
                                    <div>
                                        {idea.description &&
                                            <div className='cardDescriptionContainer' key={index + 4}>
                                                <p key={index + 3}>
                                                    {idea.description}
                                                </p>
                                            </div>
                                        }
                                    </div>
                                }
                            </div>
                        </Link>,
                    )}
                </StackGrid>
                <div className='cardEmptySpace'></div>
            </div>
        )
    }
}
CardList.propTypes = {
    filteredIdeasToShow: PropTypes.array.isRequired,
    showFields: PropTypes.string.isRequired,
}

export default CardList




// WEBPACK FOOTER //
// ./src/components/CardList.js